module.exports = __webpack_public_path__ + "img/mda_ico_4.83f985b5.svg";